import { render, staticRenderFns } from "./SpcTrafficViolations.vue?vue&type=template&id=142d1b8e&scoped=true"
import script from "./SpcTrafficViolations.vue?vue&type=script&lang=js"
export * from "./SpcTrafficViolations.vue?vue&type=script&lang=js"
import style0 from "./SpcTrafficViolations.vue?vue&type=style&index=0&id=142d1b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d1b8e",
  null
  
)

export default component.exports